import Row from './Row'

Row.install = (Vue, options) => {
  Vue.component(Row.name, Row)
}
export default Row


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Row/index.js
// module id = null
// module chunks = 